import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { StyledTitle, StyledContent, StyledButton } from './AllSet.styles'
import { Container } from '@/components/__UI'
import { getCookies } from '@/helpers/cookies'

const AllSet = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const isWebview = navigator.userAgent.includes('awz-owner-wv')
    const isIframe = getCookies('awz-iframe') === 'true'

    return (
        <Container>
            <StyledTitle>{t('allSetTitle')}</StyledTitle>
            <StyledContent>{t('nothingMoreToDo')}</StyledContent>
            {!isWebview && !isIframe ? (
                <StyledButton
                    onClick={() => navigate('/bookings/calendar')}
                    text={t('goToTheCalendar')}
                    colourScheme="brand-primary"
                />
            ) : (
                <></>
            )}
        </Container>
    )
}

export default AllSet
